import { events, EventsType } from '@/modules/notification/models/types/events.type' //TODO: REMOVE
import { Handler } from 'mitt' //TODO: REMOVE
import { vsingleton } from '@niknevis/vue-modules'
import Notify from 'quasar/src/plugins/Notify.js';
import { MessageType } from '@/modules/notification/models/types/message.type'

@vsingleton()
export class Notification {
  /*TODO: REMOVE COMMENT*/

  //TODO: REMOVE
  static open(props: EventsType['openPopup']) {
    events.emit('openPopup', props)
  }

  //TODO: REMOVE
  static listen(handler: Handler<EventsType['openPopup']>) {
    events.on('openPopup', handler)
  }

  static show(message: string, type: MessageType) {
    Notify.create({
      // timeout: 1000000,
      position: 'bottom',
      message: message,
      type: type === MessageType.Error ? 'negative' : (MessageType.Success) ? 'positive' : 'info',
      icon: type === MessageType.Error ? 'error' : (MessageType.Success) ? 'check_circle' : 'info'
    })
  }
}
